"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: #171818;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CrumbInBlack = (0, _styledComponents["default"])(_Typography["default"])(_templateObject());
/**
 * Bread crumb section used on inside the navbar
 *
 * @class NavBarBreadCrumbs
 * @extends {Component}
 * @param breadCrumb - array of the current breadCrumb
 */

var NavBarBreadCrumbs = function NavBarBreadCrumbs(_ref) {
  var subPages = _ref.subPages;

  var _useContext = (0, _react.useContext)(_wrapperContext["default"]),
      breadCrumb = _useContext.breadCrumb;

  var containerClass = (0, _classnames["default"])('navbar-bread-crumb', {
    subpages: subPages
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: containerClass
  }, (breadCrumb || []).map(function (crumb, index, list) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(CrumbInBlack, {
      variant: "h3"
    }, crumb), index !== list.length - 1 && /*#__PURE__*/_react["default"].createElement("i", {
      className: "material-icons navbar-bread-crumb-arrow"
    }, "keyboard_arrow_right"));
  }));
};

NavBarBreadCrumbs.propTypes = {
  subPages: _propTypes["default"].bool
};
var _default = NavBarBreadCrumbs;
exports["default"] = _default;